import { EditionRecord } from "../BlakeData/Types";

export interface EditionGroupRecord{
    title: string,
    shortTitle?: string,
    editions:EditionRecord[]
}

// export interface SelectedEdition {
//     edition: EditionRecord,
//     selectedItemIndex: number
// }

export interface ActiveIndex{
    groupIndex:number,
    editionIndex:number,
    printIndex:number
}

export const emptyActiveIndex:ActiveIndex = {
    groupIndex:-1,
    editionIndex:-1,
    printIndex:-1
}